import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import bundesligaBackgroundWide from './assets/background-bundesliga-wide.jpg';
import bundesligaBackground from './assets/background-bundesliga.jpg';
import laligaBackgroundWide from './assets/background-laliga-wide.jpg';
import laligaBackground from './assets/background-laliga.jpg';
import ligue1BackgroundWide from './assets/background-ligue1-wide.jpg';
import ligue1Background from './assets/background-ligue1.jpg';
import nbaBackgroundWide from './assets/background-nba-wide.jpg';
import nbaBackground from './assets/background-nba.jpg';
import plBackgroundWide from './assets/background-pl-wide.jpg';
import plBackground from './assets/background-pl.jpg';
import sorareBackgroundWide from './assets/background-sorare-wide.jpg';
import sorareBackground from './assets/background-sorare.jpg';

const PACK_ASSETS: Record<
  string,
  { background: string; backgroundWide: string }
> = {
  'premier-league-gb-eng': {
    background: plBackground,
    backgroundWide: plBackgroundWide,
  },
  'laliga-es': {
    background: laligaBackground,
    backgroundWide: laligaBackgroundWide,
  },
  'bundesliga-de': {
    background: bundesligaBackground,
    backgroundWide: bundesligaBackgroundWide,
  },
  'ligue-1-fr': {
    background: ligue1Background,
    backgroundWide: ligue1BackgroundWide,
  },
  sorare: {
    background: sorareBackground,
    backgroundWide: sorareBackgroundWide,
  },
  nba: {
    background: nbaBackground,
    backgroundWide: nbaBackgroundWide,
  },
};

export const usePackAssets = ({
  cardPackGroupId,
}: {
  cardPackGroupId: Nullable<string>;
}) => {
  const { sport } = useSportContext();
  let bgImage =
    PACK_ASSETS[cardPackGroupId || 'sorare']?.background ||
    PACK_ASSETS.sorare.background;
  let bgImageWide =
    PACK_ASSETS[cardPackGroupId || 'sorare']?.backgroundWide ||
    PACK_ASSETS.sorare.backgroundWide;

  if (sport === Sport.NBA) {
    bgImage = PACK_ASSETS.nba.background;
    bgImageWide = PACK_ASSETS.nba.backgroundWide;
  }
  return { bgImage, bgImageWide };
};
